import { atom } from 'jotai'

export const isContractsUploadingAtom = atom<boolean>(false)
